import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  ApiBuilder,
  AppConfigService,
  HttpHeadersPayload,
  HttpRequestMethods,
  ReplaceItem,
  handleError
} from '@com-delta-idp/mnx-utils';
import { Observable } from 'rxjs';
import {
  EndpointKey,
  IDP_APP,
  MFA_OAUTH_URL
} from '../../../constants/multi-factor-authentication-constant';
import { OauthAEMConfig } from '../../../models';
import { InitiateAuthentication } from '../../../models/multi-factor-authentication.interfaces';
import { UtilService } from '../../util-service/util-service';

@Injectable({
  providedIn: 'root'
})
export class InitiateAuthenticationService {
  initiateAuthenticationHeader: HttpHeadersPayload = {
    'Content-Type': 'application/vnd.pingidentity.authenticate+json',
    'X-XSRF-Header': 'PingFederate',
    rejectUnauthorized: 'false'
  };

  _errorHandler = handleError.bind(this);

  constructor(
    private http: HttpClient,
    private appConfig: AppConfigService,
    private utils: UtilService
  ) {}

  initiateAuthentication = (
    authConfig: OauthAEMConfig,
    flowIdValue: string
  ): Observable<InitiateAuthentication> => {
    const getInitiateAuthenticationUrl = this.utils.getPingServiceUrl(
      authConfig,
      flowIdValue
    ).loginAuthWithCredentialsUrl;

    const initiateAuthenticationUrl: ReplaceItem[] = [
      {
        src: MFA_OAUTH_URL,
        target: getInitiateAuthenticationUrl
      }
    ];

    return new ApiBuilder<undefined, InitiateAuthentication>(
      this.http,
      this.appConfig
    )
      .app(IDP_APP.COMMON)
      .endpointKey(EndpointKey.MFA_OAUTH_URL)
      .overrideEndpoint(initiateAuthenticationUrl)
      .method(HttpRequestMethods['POST'])
      .timeOut(authConfig.MFA_TIMEOUT ?? 10000)
      .httpHeaders(this.initiateAuthenticationHeader)
      .errorHandler(this._errorHandler)
      .library('INITIATE_AUTHENTICATION_SERVICE')
      .withCredentials(true)
      .create();
  };
}
